/**
 * ActionButton - Full-Width Call-to-Action
 * 
 * Design: Icon + Label, generous padding, obvious tap target
 * No visual tricks - purpose is immediately clear
 */

import React from 'react';
import './actionbutton.css';

export default function ActionButton({ icon, label, onClick, variant = 'primary' }) {
  return (
    <button className={`action-button action-button--${variant}`} onClick={onClick}>
      <span className="action-button__icon">{icon}</span>
      <span className="action-button__label">{label}</span>
    </button>
  );
}
